import React, { useState } from "react";
import {
  Edit2,
  FilterRemove,
  Send2,
} from "iconsax-react";
import { MESSAGE_BLAST_EDIT } from "../../Router/path";
import { useNavigate } from "react-router-dom";
import FilterTextInput from "../../Components/FilterTextInput";
import MessageBlastPopUp from "../../Components/MessageBlastPopUp";
import axios from "axios";
import {
  MESSAGE_GUEST_OPTIONS_API,
  GET_GUEST_COUNT_API,
} from "../../Constant/api";
import { useToast } from "../../Components/Toast";
import { LoadingOverlay } from "../../Components/LoadingOverlay";
import { motion as m } from "framer-motion";
import Paginator from "../../Components/Paginator";
import Can from "../../Components/Can";

const MessageBlastTable = ({
  data,
  meta,
  handlePageClick,
  currentTab,
  searchTerm,
  handleSearch,
  handleKeyDown,
  perPage,
  handlePerPageChange,
  clearFilter,
}) => {
  const [showSend, setShowSend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [guestCount, setGuestCount] = useState();
  const [guestOptions, setGuestOptions] = useState();
  const [templateToSend, setTemplateToSend] = useState();
  const navigate = useNavigate();

  const { toast } = useToast();

  const showSendPopUp = () => {
    setShowSend(true);
  };

  const togglePopUp = () => {
    setShowSend(!showSend);
  };

  const fetchGuestCount = () => {
    setLoading(true);
    try {
      axios
        .get(GET_GUEST_COUNT_API, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          params: {
            eventId: sessionStorage.getItem("event_id"),
            type: currentTab === "email" ? "email" : "whatsapp",
            templateId: templateToSend,
          },
        })
        .then((res) => {
          setLoading(false);
          setGuestCount(res.data.data);
          fetchGuestOptions();
        })
        .catch((err) => {
          setLoading(false);
          toast("Failed to fetch guest count", "error");
          console.log(err);
        });
    } catch (err) {
      setLoading(false);
      toast("Failed to fetch guest count", "error");
      console.log(err);
    }
  };

  const fetchGuestOptions = () => {
    setLoading(true);
    try {
      axios
        .get(MESSAGE_GUEST_OPTIONS_API, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          params: {
            eventId: sessionStorage.getItem("event_id"),
            type: currentTab === "email" ? "email" : "whatsapp",
          },
        })
        .then((res) => {
          setLoading(false);
          setGuestOptions(res.data.data);
          showSendPopUp();
        })
        .catch((err) => {
          setLoading(false);
          toast("Failed to fetch guest options", "error");
          console.log(err);
        });
    } catch (err) {
      setLoading(false);
      toast("Failed to fetch guest options", "error");
      console.log(err);
    }
  };

  return (
    <m.div
      className="flex flex-col border border-[#EFF0F2] w-full h-fit bg-white rounded-xl"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {loading && <LoadingOverlay />}

      {/* Send Email Pop Up */}
      {showSend && guestCount && guestOptions && !loading && (
        <MessageBlastPopUp
          togglePopUp={togglePopUp}
          guestCount={guestCount}
          guestOptions={guestOptions}
          templateId={templateToSend}
          setLoading={setLoading}
          type={currentTab === "email" ? "email" : "whatsapp"}
        />
      )}

      {/* Filters */}
      <div className="flex w-full border-b border-[#EFF0F2] px-[24px] py-[12px] gap-[8px] items-center justify-end">
        {clearFilter && searchTerm !== "" && (
          <FilterRemove
            size="16"
            onClick={clearFilter}
            variant="Bold"
            className="text-[#FF3030] hover:cursor-pointer hover:text-[#5C4BF5]"
          />
        )}
        <FilterTextInput
          value={searchTerm}
          onChange={handleSearch}
          onKeyDown={handleKeyDown}
        />
      </div>

      {/* Dashboard data */}
      <div className="flex w-full min-h-[290px] gap-[24px] no-scrollbar overflow-x-auto">
        {!data || data.length === 0 ? (
          <div className="flex w-full items-center border-[#EFF0F2] justify-center text-gray-500 text-[25px]">
            No template found
          </div>
        ) : (
          <table className="w-full h-full text-nowrap">
            {/* Table Header */}
            <tr className="bg-[#F7F8F9]">
              <th className="text-start px-[24px] py-[16px]">Template Name</th>
              {currentTab === "email" && (
                <th className="text-start px-[24px] py-[16px]">Subject</th>
              )}
              <th className="text-start px-[24px] py-[16px]"></th>
            </tr>

            {/* Table Body */}
            {data &&
              data.map((item) => (
                <tr
                  key={item.id}
                  className="font-normal border-y border-[#EFF0F2]"
                >
                  <td className="px-[24px] py-[16px]">{item.name ?? "-"}</td>
                  {currentTab === "email" && (
                    <td className="px-[24px] py-[16px]">
                      {item.subject ?? "-"}
                    </td>
                  )}
                  <td className="flex px-[24px] py-[16px] gap-[12px] justify-end">
                    <Can permission="send_message_blast">
                      <span
                        className="flex text-[#636C7E] text-[14px] items-center hover:underline cursor-pointer"
                        onClick={() => {
                          setTemplateToSend(item.id);
                          fetchGuestCount();
                        }}
                      >
                        <Send2 size="15" variant="Bold" />
                        Send
                      </span>
                    </Can>
                    <Can permission="edit_message_blast">
                      <span
                        className="flex text-[#5C4BF5] text-[14px] items-center hover:underline cursor-pointer"
                        onClick={() =>
                          navigate(MESSAGE_BLAST_EDIT, {
                            state: { recordId: item.id, type: currentTab },
                          })
                        }
                      >
                        <Edit2 size="15" variant="Bold" />
                        Edit
                      </span>
                    </Can>
                  </td>
                </tr>
              ))}
          </table>
        )}
      </div>

      {/* Pagination */}
      {meta && (
        <Paginator
          meta={meta}
          perPage={perPage}
          handlePerPageChange={handlePerPageChange}
          handlePageClick={handlePageClick}
        />
      )}
    </m.div>
  );
};

export default MessageBlastTable;
